module.exports = __webpack_public_path__ + "static/media/marketplace.5d6e38ad.svg";